import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import { FormattedMessage } from 'react-intl';
import bootstrap from 'bootstrap/dist/css/bootstrap.css';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import s from '../../../assets/styles/style.sass';
import s2 from '../login.sass';
// import LoginRegisterMessagesRef from '../LoginRegisterMessageRef';
import { register, fbuserProfileUpdate } from '../../../api/user';
import {
  setUserInfo,
  setUserPassword,
  setIsShowRegisterModal,
  setIsShowUpdateUserModal,
} from '../../../actions/user';
import { getAuth, setAuth } from '../../../service/auth';
import { getLink } from '../../../service/asset-json';


class RegisterButton extends React.Component {
  static propTypes = {
    currentLocale: PropTypes.string.isRequired,
    isFromUpdateUserInfoModal: PropTypes.bool,
    user: PropTypes.shape({
      email: PropTypes.string.isRequired,
      phone: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      password: PropTypes.string,
      has_agreed_to_receive_gogovan_updates: PropTypes.bool.isRequired,
      has_agreed_to_receive_third_parties_updates: PropTypes.bool.isRequired,
    }).isRequired,
    email: PropTypes.string,
    password: PropTypes.string,
    password_1: PropTypes.string,
    password_2: PropTypes.string,
    setErrorCode: PropTypes.func.isRequired,
    setUserInfo: PropTypes.func.isRequired,
    setUserPassword: PropTypes.func.isRequired,
    setIsShowRegisterModal: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired,
    onClickisClickButton: PropTypes.func,
    className: PropTypes.string,
  };

  static defaultProps = {
    isFromUpdateUserInfoModal: false,
    password_1: '',
    password_2: '',
    email: '',
    password: '',
    onClickisClickButton: () => {},
    className: '',
  };

  constructor(props) {
    super(props);
    const langType = props.currentLocale.split('-')[0];
    const lang = props.currentLocale.split('-')[1].toLowerCase();
    let fileLang = '';
    if (lang === 'hk') {
      fileLang = `${langType}_${lang}/`;
    }
    this.state = {
      modelDataDefaultLink: require(`../../../assets/json/default/setting/general/link.json`),
      modelDataLink: require(`../../../assets/json/${lang}/${fileLang}setting/general/link.json`),
      setting: require(`../../../assets/src/${lang}/scripts/components/setting.json`),
      lang,
    };
    this.onClickRegister = this.onClickRegister.bind(this);
  }

  onClickRegister() {
    const { user, currentLocale } = this.props;
    let json = {
      user: {
        email: this.props.user.email,
        password: this.props.password_1,
        phone_number: ['sg'].includes(this.state.lang)
          ? this.props.user.phone.toString()
          : parseInt(this.props.user.phone, 10),
        name: this.props.user.name,
        has_agreed_to_receive_gogovan_updates: this.props.user
          .has_agreed_to_receive_gogovan_updates,
        has_agreed_to_receive_third_parties_updates: this.props.user
          .has_agreed_to_receive_third_parties_updates,
      },
    };

    // if is normal register, not fb register
    if (!this.props.isFromUpdateUserInfoModal) {
      this.props.setUserPassword(this.props.password_1);
      // check whether register is valid
      let isPassCheck = true;
      Object.entries(json.user).forEach(item => {
        if (item[1] === '') {
          isPassCheck = false;
        }
      });
      if (this.props.password_1 === '') {
        isPassCheck = false;
      }
      if (!isPassCheck) return false;
    }

    // check phone pattern
    const patt = new RegExp(this.state.setting.PHONE_REGEX);
    if (!patt.test(user.phone) && user.phone !== '') {
      return this.props.setErrorCode(4);
    }

    // check email pattern
    const emailPatt = new RegExp(this.state.setting.EMAIL_REGEX);
    if (!emailPatt.test(user.email) && user.email !== '') {
      return this.props.setErrorCode(0);
    }

    if (this.props.isFromUpdateUserInfoModal) {
      this.props.setErrorCode(0);
      json = {
        phone_number: parseInt(this.props.user.phone, 10),
      };

      const fbAuth = {
        user: {
          email: this.props.email,
          password: this.props.password,
        },
      };
      fbuserProfileUpdate(fbAuth, json, this.props.currentLocale, null)
        .then(response => response.json())
        .then(result => {
          if (typeof result.error !== 'undefined') {
            return this.props.setErrorCode(7);
          }
          setAuth(
            result.id,
            result.name,
            result.email,
            result.session_token,
            result.phone_number,
            result.verified,
            getAuth().addresses,
            result.meta,
            result.gender,
            result.industry,
            result.date_of_birth,
            result.profile_photo,
          );
          this.props.setUserInfo(result.user);
          setTimeout(() => {
            setIsShowUpdateUserModal();
            const href =
              typeof this.state.modelDataLink['order'] === 'undefined'
                ? this.state.modelDataDefaultLink['order']
                : this.state.modelDataLink['order'];
            window.location.href = href;
          }, 500);
          return '';
        })
        .catch(error => {
          console.warn('Request failed', error);
        });
    } else {
      if (this.props.password_1.length < 8) {
        return this.props.setErrorCode(1);
      }
      if (this.props.password_1 !== this.props.password_2) {
        return this.props.setErrorCode(2);
      }
      this.props.setUserPassword(this.props.password_1);
      if (user.name.length < 1) {
        return console.warn('Name cannot be empty');
      }

      register(json, this.props.currentLocale)
        .then(response => response.json())
        .then(result => {
          let errorCode = 0;
          if (typeof result.errors !== 'undefined') {
            for (let i = 0; i < Object.keys(result.errors).length; i += 1) {
              if (Object.keys(result.errors)[i] === 'email') {
                errorCode += 6;
              } else if (Object.keys(result.errors)[i] === 'phone_number') {
                errorCode += 7;
              }
            }
          }
          if (errorCode !== 0) {
            return this.props.setErrorCode(errorCode);
          }
          setAuth(
            result.user.id,
            result.user.name,
            result.user.email,
            result.user.session_token,
            result.user.phone_number,
            result.user.verified,
            getAuth().addresses,
            result.user.meta,
            result.user.gender,
            result.user.industry,
            result.user.date_of_birth,
            result.user.profile_photo,
          );
          this.props.setUserInfo(result.user);
          this.props.setIsShowRegisterModal();

          window.location.href = getLink('order', currentLocale);

          return '';
        })
        .catch(error => {
          console.warn('Request failed', error);
        });
    }
    return '';
  }

  render() {
    return (
      <button
        type="submit"
        onClick={() => {
          this.props.onClickisClickButton();
          this.onClickRegister();
        }}
        className={`${s2.button} ${s2.register}`}
        block
      >
        {this.props.text}
      </button>
    );
  }
}
const mapState = state => ({
  email: state.user.email,
  password: state.user.password,
  user: state.user,
  currentLocale: state.intl.locale,
});
const mapDispatch = {
  setUserInfo,
  setUserPassword,
  setIsShowRegisterModal,
  setIsShowUpdateUserModal,
};
export default connect(mapState, mapDispatch)(
  withStyles(bootstrap, s, s2)(RegisterButton),
);



// WEBPACK FOOTER //
// ./src/components/Login/LoginButton/RegisterButton.js